import { render, staticRenderFns } from "./TradePageGpList.vue?vue&type=template&id=34da4153&scoped=true&"
import script from "./TradePageGpList.vue?vue&type=script&lang=js&"
export * from "./TradePageGpList.vue?vue&type=script&lang=js&"
import style0 from "./TradePageGpList.vue?vue&type=style&index=0&id=34da4153&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da4153",
  null
  
)

export default component.exports